import React from 'react';

export const Pause = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '20'}
    height={height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_830_30780"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width={width || '20'}
      height={height || '20'}
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_830_30780)">
      <path
        d="M7.50008 12.5C7.50008 12.9602 7.87318 13.3333 8.33342 13.3333C8.79365 13.3333 9.16675 12.9602 9.16675 12.5V7.49996C9.16675 7.03972 8.79365 6.66663 8.33342 6.66663C7.87318 6.66663 7.50008 7.03972 7.50008 7.49996V12.5ZM10.8334 12.5C10.8334 12.9602 11.2065 13.3333 11.6667 13.3333C12.127 13.3333 12.5001 12.9602 12.5001 12.5V7.49996C12.5001 7.03972 12.127 6.66663 11.6667 6.66663C11.2065 6.66663 10.8334 7.03972 10.8334 7.49996V12.5ZM10.0001 18.3333C8.8473 18.3333 7.76397 18.1144 6.75008 17.6766C5.73619 17.2394 4.85425 16.6458 4.10425 15.8958C3.35425 15.1458 2.76064 14.2638 2.32341 13.25C1.88564 12.2361 1.66675 11.1527 1.66675 9.99996C1.66675 8.84718 1.88564 7.76385 2.32341 6.74996C2.76064 5.73607 3.35425 4.85413 4.10425 4.10413C4.85425 3.35413 5.73619 2.76024 6.75008 2.32246C7.76397 1.88524 8.8473 1.66663 10.0001 1.66663C11.1529 1.66663 12.2362 1.88524 13.2501 2.32246C14.264 2.76024 15.1459 3.35413 15.8959 4.10413C16.6459 4.85413 17.2395 5.73607 17.6767 6.74996C18.1145 7.76385 18.3334 8.84718 18.3334 9.99996C18.3334 11.1527 18.1145 12.2361 17.6767 13.25C17.2395 14.2638 16.6459 15.1458 15.8959 15.8958C15.1459 16.6458 14.264 17.2394 13.2501 17.6766C12.2362 18.1144 11.1529 18.3333 10.0001 18.3333ZM10.0001 16.6666C11.8612 16.6666 13.4376 16.0208 14.7292 14.7291C16.0209 13.4375 16.6667 11.8611 16.6667 9.99996C16.6667 8.13885 16.0209 6.56246 14.7292 5.27079C13.4376 3.97913 11.8612 3.33329 10.0001 3.33329C8.13897 3.33329 6.56258 3.97913 5.27091 5.27079C3.97925 6.56246 3.33341 8.13885 3.33341 9.99996C3.33341 11.8611 3.97925 13.4375 5.27091 14.7291C6.56258 16.0208 8.13897 16.6666 10.0001 16.6666Z"
        fill={color || '#FF8F73'}
      />
    </g>
  </svg>
);
